import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";

const columns = [
  {
    field: "id",
    headerName: "ID",
    /*width: 20*/ headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "name",
    headerName: null /*width: 140*/,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "jan",
    headerName: "Jan",
    type: "number",
    width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "feb",
    headerName: "Feb",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "mar",
    headerName: "Mar",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "apr",
    headerName: "Apr",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "may",
    headerName: "May",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "jun",
    headerName: "Jun",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "jul",
    headerName: "Jul",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "aug",
    headerName: "Avg",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "sep",
    headerName: "Sep",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "oct",
    headerName: "Okt",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "nov",
    headerName: "Nov",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
  {
    field: "dec",
    headerName: "Dec",
    type: "number",
    // width: 70,
    valueFormatter: ({ value }) => `${value} °C`,
    headerClassName: "header-style",
    flex: 1,
  },
];

/*const rows = [
  { id: 1, name: 'Dry Buld', jan: 5, feb: 7, mar: 14, apr: 18, may: 25, jun: 28, jul: 26, aug: 30, sep: 24, oct: 22, nov: 14, dec: 12 },
  { id: 2, name: 'Wet Buld', jan: 5, feb: 6, mar: 10, apr: 12, may: 20, jun: 19, jul: 19, aug: 21, sep: 20, oct: 16, nov: 9, dec: 8 },
  { id: 3, name: 'Mean Daily Range', jan: 7, feb: 7, mar: 9, apr: 11, may: 13, jun: 12, jul: 13, aug: 12, sep: 12, oct: 12, nov: 11, dec: 8 },
];*/

function TableDryWetMean(temp) {
  const rows = [
    {
      id: 1,
      name: "Dry Buld",
      jan: temp.dryBulbTemperatures[0],
      feb: temp.dryBulbTemperatures[1],
      mar: temp.dryBulbTemperatures[2],
      apr: temp.dryBulbTemperatures[3],
      may: temp.dryBulbTemperatures[4],
      jun: temp.dryBulbTemperatures[5],
      jul: temp.dryBulbTemperatures[6],
      aug: temp.dryBulbTemperatures[7],
      sep: temp.dryBulbTemperatures[8],
      oct: temp.dryBulbTemperatures[9],
      nov: temp.dryBulbTemperatures[10],
      dec: temp.dryBulbTemperatures[11],
    },
    {
      id: 2,
      name: "Wet Buld",
      jan: temp.wetBulbTemperatures[0],
      feb: temp.wetBulbTemperatures[1],
      mar: temp.wetBulbTemperatures[2],
      apr: temp.wetBulbTemperatures[3],
      may: temp.wetBulbTemperatures[4],
      jun: temp.wetBulbTemperatures[5],
      jul: temp.wetBulbTemperatures[6],
      aug: temp.wetBulbTemperatures[7],
      sep: temp.wetBulbTemperatures[8],
      oct: temp.wetBulbTemperatures[9],
      nov: temp.wetBulbTemperatures[10],
      dec: temp.wetBulbTemperatures[11],
    },
    {
      id: 3,
      name: "Mean Daily Range",
      jan: temp.meanDailyTemperatureRange[0],
      feb: temp.meanDailyTemperatureRange[1],
      mar: temp.meanDailyTemperatureRange[2],
      apr: temp.meanDailyTemperatureRange[3],
      may: temp.meanDailyTemperatureRange[4],
      jun: temp.meanDailyTemperatureRange[5],
      jul: temp.meanDailyTemperatureRange[6],
      aug: temp.meanDailyTemperatureRange[7],
      sep: temp.meanDailyTemperatureRange[8],
      oct: temp.meanDailyTemperatureRange[9],
      nov: temp.meanDailyTemperatureRange[10],
      dec: temp.meanDailyTemperatureRange[11],
    },
  ];

  return (
    <Box>
      <div style={{ height: 280, width: "100%" }}>
        <DataGrid
          width={"100%"}
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </div>
    </Box>
  );
}

export default TableDryWetMean;
